import { FLAGS } from '../../constants';

export const DEFAULT_TREATMENT = { treatment: 'off', config: '{}' };

export default {
  [FLAGS.SINGPASS_LOGIN]: DEFAULT_TREATMENT,
  [FLAGS.DECOUPLE_LUCKY_DRAW]: DEFAULT_TREATMENT,
};
